import { makeRequest } from "../helpers/makeRequest";
import { prepareUrlWithQueryParams } from "../helpers/methods";
import { useAxiosPrivate } from "../hooks/useAxiosPrivate";

export default function useFooService() {
    const axiosPrivate = useAxiosPrivate();

    const getFooDetails = (fooId) => {
        return makeRequest(axiosPrivate, `mock-url${fooId}`);
    };

    const createFoo = (fooData) => {
        return makeRequest(axiosPrivate, "mock-url", {
            method: "POST",
            data: fooData,
        });
    };

    const updateFoo = (fooId, fooData) => {
        return makeRequest(axiosPrivate, `mock-url${fooId}`, {
            method: "PATCH",
            data: fooData,
        });
    };

    const getFooListData = () => {
        return makeRequest(axiosPrivate, "mock-url");
    };

    const getFooListDataWithSearchParams = (searchParams = undefined) => {
        return Promise.resolve([]);
    };

    return {
        getFooDetails,
        createFoo,
        updateFoo,
        getFooListData,
        getFooListDataWithSearchParams,
    };
}
